export const filesActions = {
	readFileAsDataURL,
	normalizeUploadFileList
}

function readFileAsDataURL(file){
	return new Promise((resolve, reject) => {
		const fr = new FileReader()
		fr.onload = () => {
			resolve(fr.result)
		}
		fr.onerror = reject
		fr.readAsDataURL(file)
	})
}
function normalizeUploadFileList(e){
	if (Array.isArray(e))
		return e
	return e?.fileList
}